import React, {useEffect, useState} from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl'



const FilterItem = props => {
    useStyles(classes)
    const { filterItem, value, onChange } = props

    const handleClick = (s, fieldName) => {
        const existSelection = value?.selections?.some(selection => selection.value === s.value)
        let newValue
        if (existSelection) {
            newValue = {
                ...value,
                fieldName,
                selections: value?.selections?.filter(selection => selection.value !== s.value)
            }
        } else {
            newValue = {
                ...value,
                fieldName,
                selections: [...(value?.selections || []), s]
            }
        }
        onChange(newValue)
    }

    const isActive = s => {
        return value?.selections?.some?.(selection => selection.value === s.value)
    }

    return <div className={classes.FilterItem}>
        <div className={classes.Bd}>
            {
                filterItem?.selections?.map(selection => <span onClick={() => { handleClick(selection, filterItem.fieldName) }} className={`${classes.Selection} ${isActive(selection) ? classes.Active : ''}`} key={selection.value}>{selection.label}</span>)
            }
        </div>
    </div>
}

const FilterPanel = props => {
    useStyles(classes)
    const { filterItem, value, onChange } = props
    const getExactValue = fn => {
        return value?.find(v => v.fieldName === fn)
    }

    const changeHandle = exactValue => {
        const exist = value?.some(v => v.fieldName === exactValue.fieldName)
        let newValue
        if (exist) {
            newValue = value?.map(v => {
                if (v.fieldName === exactValue.fieldName) {
                    return exactValue
                }
                return v
            })
        } else {
            newValue = [...(value || []), exactValue]
        }

        onChange(newValue)

    }

    return <div className={classes.FilterItems}>
        <FilterItem onChange={changeHandle} value={getExactValue(filterItem.fieldName)} key={filterItem.fieldName} filterItem={filterItem} />
    </div>
}

export default props => {

    useStyles(classes)

    const { value, filterItem } = props

    const [filterValue, setFilterValue] = useState(value)

    useEffect(() => {
        setFilterValue(value)
    }, [
        JSON.stringify(value)
    ])


    const changeHandle = v => {
        setFilterValue(v)
    }

    const handleSubmit = () => {
        props?.onSubmit(filterValue)
        props?.onClose()
    }

    const handleClear = () => {
        const exist = value?.some(v => v.fieldName === filterItem.fieldName)
        let newValue
        if (exist) {
            newValue = value?.map(v => {
                if (v.fieldName === filterItem.fieldName) {
                    return { ...filterItem, selections: [] }
                }
                return v
            })
        } else {
            newValue = [...(value || []), { ...filterItem, selections: [] }]
        }

        setFilterValue(newValue)
    }


    return <div className={classes.SingleFilterPage}>
        <div className={classes.Bd}>
            <FilterPanel filterItem={filterItem} value={filterValue} onChange={changeHandle} />
        </div>
        <div className={classes.Fd}>
            <button onClick={() => { handleClear() }} className={classes.OpBtn}><FormattedMessage id="clear" defaultMessage="Clear" /></button>
            <button onClick={() => { handleSubmit() }} className={`${classes.OpBtn} ${classes.Active}`}><FormattedMessage id="apply" defaultMessage="Apply" /></button>
        </div>
    </div>
}